import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import PlatformConditional from 'Components/PlatformConditional';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';
import { useIntl } from 'react-intl';

const ProceduresHistory = ({ documents, startEdit, setProcedureCode }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  return (
    <>
      <PlatformConditional platform={['mgravis', 'polyneuro']}>
        <HistorySection
          headerText={fm('procedure.plasmaChange')}
          newButton={
            <DocumentCreationButton
              name="procedure"
              text={'procedure.newPlasmaChange'}
              onClick={(e: React.MouseEvent): void => {
                setProcedureCode?.('19647005');
                startEdit({}, 'procedure', {
                  code: {
                    codeSystem: 'http://snomed.info/sct',
                    code: '19647005',
                    display: fm('procedure.plasmaChange'),
                  },
                })(e);
              }}
              width={15}
              height={3}
              fontSize={14}
              alternate={true}
            />
          }
        >
          <HistoryRowListing
            documents={documents.filter(d => d.code?.code === '19647005')}
            headers={
              <>
                <Item xs={3}>{fm('general.date')}</Item>
                <Item xs={9}>{fm('procedure.additionalInformation')}</Item>
              </>
            }
            contentFormat={(d): React.JSX.Element => (
              <>
                <Item xs={3} style={{ fontWeight: '600' }}>
                  {formatPartialDate(d.date)}
                </Item>
                <Item xs={6}>{d.additionalInformation ?? '-'}</Item>

                <Item xs={3}>
                  <HistoryRowControls
                    document={d}
                    startEdit={d => e => {
                      setProcedureCode?.('19647005');
                      startEdit(d)(e);
                    }}
                  />
                </Item>
              </>
            )}
          />
        </HistorySection>
      </PlatformConditional>
      <PlatformConditional platform={'mgravis'}>
        <HistorySection
          headerText={fm('procedure.thymectomy')}
          newButton={
            <DocumentCreationButton
              name="procedure"
              text={'procedure.newThymectomy'}
              onClick={(e: React.MouseEvent): void => {
                setProcedureCode?.('399750009');
                startEdit({}, 'procedure', {
                  code: {
                    codeSystem: 'http://snomed.info/sct',
                    code: '399750009',
                    display: fm('procedure.thymectomy'),
                  },
                })(e);
              }}
              width={15}
              height={3}
              fontSize={14}
              alternate={true}
            />
          }
        >
          <HistoryRowListing
            documents={documents.filter(d => d.code?.code === '399750009')}
            headers={
              <>
                <Item xs={3}>{fm('general.date')}</Item>
                <Item xs={3}>{fm('procedure.additionalInformation')}</Item>
                <Item xs={6}>{fm('procedure.finding.pad')}</Item>
              </>
            }
            contentFormat={d => (
              <>
                <Item xs={3} style={{ fontWeight: '600' }}>
                  {formatPartialDate(d.date)}
                </Item>
                <Item xs={3}>{d.additionalInformation ?? '-'}</Item>
                <Item xs={3}>
                  {Array.isArray(d.finding)
                    ? d.finding.map(find => fm(`procedure.finding.${find}`)).join(', ')
                    : d.finding
                      ? fm(`procedure.finding.${d.finding}`)
                      : '-'}
                </Item>
                <Item xs={3}>
                  <HistoryRowControls
                    document={d}
                    startEdit={d => e => {
                      setProcedureCode?.('399750009');
                      startEdit(d)(e);
                    }}
                  />
                </Item>
              </>
            )}
          />
        </HistorySection>
      </PlatformConditional>
    </>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'procedure'>>;
  startEdit: StartEdit;
  setProcedureCode?: React.Dispatch<React.SetStateAction<string>>;
}

export default ProceduresHistory;
